// TODO(@ibedwi): Navbar - AddOption
// TODO(@ibedwi): Navbar - AlignOption
// TODO(@ibedwi): Navbar - MenuOptions
// TODO(@ibedwi): Navbar - Position Options
// TODO(@ibedwi): Navbar - Remove Options
// TODO(@ibedwi): Navbar - Set Style

import { Navbar2Element } from '@typedream/core';
import { getNode, setNodes, removeNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { ELEMENT_NAVBAR } from '../../../pluginKeys';
import { DreamEditor } from '../../../types';

export const changeNavbarTitle = (
  editor: DreamEditor,
  at: Path,
  newTitle: string,
) => {
  const element = getNode(editor, at);

  if (element?.type !== ELEMENT_NAVBAR) return;

  setNodes(editor, {
    ...element,
    logoTitle: newTitle,
  }, { at });
};

export const changeNavbarLogo = (
  editor: DreamEditor,
  at: Path,
  newNavbar?: Navbar2Element,
) => {
  const element = getNode(editor, at);

  if (element?.type !== ELEMENT_NAVBAR || !newNavbar) return;

  setNodes(
    editor,
    newNavbar,
    { at },
  );
};

export const changeNavbar = (
  editor: DreamEditor,
  at: Path,
  newNavbar?: Navbar2Element,
) => {
  const element = getNode(editor, at);

  if (element?.type !== ELEMENT_NAVBAR || !newNavbar) return;

  setNodes(
    editor,
    newNavbar,
    { at },
  );
};

export const removeNavbar = (
  editor: DreamEditor,
  at: Path,
) => {
  removeNodes(
    editor,
    { at },
  );
};
